var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"colored-progress",style:({color: _vm.percentColor})},[(!_vm.scoreOnly)?[_vm._v("Score: ")]:_vm._e(),_vm._v(_vm._s(_vm.progress || 0)+"% ")],2)}
var staticRenderFns = []

export { render, staticRenderFns }